// components/Layout/Toast.jsx
import { useToast } from '../../hooks/useToast';

const icons = { success: '✓', error: '✗', info: '●', warning: '⚠' };
const colors = { success: 'border-green-500/40 text-green-400 bg-green-500/5', error: 'border-red-500/40 text-red-400 bg-red-500/5', info: 'border-gray-600 text-gray-300 bg-gray-500/5', warning: 'border-yellow-500/40 text-yellow-400 bg-yellow-500/5' };

export function ToastContainer() {
  const { toasts, removeToast } = useToast();
  if (toasts.length === 0) return null;
  return (<div className="fixed bottom-5 right-5 z-[200] flex flex-col gap-2 max-w-xs">{toasts.map((t) => (<div key={t.id} onClick={() => removeToast(t.id)} className={`animate-slide-in-right flex items-start gap-3 px-4 py-3 rounded-xl backdrop-blur-md border cursor-pointer text-sm font-mono shadow-xl ${colors[t.type] || colors.info}`}><span className="font-bold text-base mt-0.5">{icons[t.type] || '●'}</span><span>{t.message}</span></div>))}</div>);
}
